export default __webpack_public_path__ + "static/Tree-2a123ca0aee3c615a81ce94d31cf4bd1.png";